<template>
    <div>
        <!-- 轮播图 -->
        <div class="bg">
            <div class="sub-title">Milestone</div>
            <div class="title">发展历程</div>
        </div>
        <div class="p-3">
            <el-timeline>
                <el-timeline-item placement="top" v-for="(item, index) in milestoneList" :key="index">
                    <div class="flex-row justify-around">
                        <div>
                            <div class="sub-time">{{ item.occuDate }}</div>
                        </div>
                        <div style="width: 200px;">
                            <div>{{ item.title }}</div>
                            <!-- <p>{{item.title}}</p> -->
                        </div>
                    </div>
                </el-timeline-item>
            </el-timeline>
        </div>
    </div>
</template>
  
<script type="text/babel">
export default {
    name: "HomePage",
    data() {
        return {

            milestoneList:[
               
            ]
        };
    },
    methods: {

    },
    mounted() {
        /* banner-swiper */
        debugger
            let that=this;
            this.http.post("/api/FJ_Milestone/GetAllMilestone",JSON.stringify({})).then((result)=>{
                debugger
            let objResult= eval(result);
            let iCode= objResult.code;
            if(iCode==0){
                debugger
                that.milestoneList=objResult.data;
                }
            });
    }
};
</script>
  
<style scoped lang="scss">
.bg {
    background: url('../../assets/img/milestonebanner.jpg') no-repeat;
    background-size: 100% ;
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.sub-title {
    display: inline-block;
    background-color: #0AA00A;
    color: #fff;
    border-radius: 5px;
    border-top-right-radius: 0;
    font-size: 12px;
    padding: 2px 5px;
}
.title {
    font-size: 20px;
    font-weight: 700;
    margin-top: 5px;
}

.p-3 {
    padding: 15px;
}

.sub-time {
    display: flex;
    background-color: #0AA00A;
    color: #fff;
    padding: 4px;
    border-radius: 5px;
}
</style>
  


// WEBPACK FOOTER //
// src/views/milestone/m_index.vue